import { render, staticRenderFns } from "./modal-base.vue?vue&type=template&id=b20b20dc&"
import script from "./modal-base.vue?vue&type=script&lang=js&"
export * from "./modal-base.vue?vue&type=script&lang=js&"
import style0 from "./modal-base.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SignupForm: require('/usr/src/app/components/auth-modal/signup-form.vue').default,LoginForm: require('/usr/src/app/components/auth-modal/login-form.vue').default,PasswordResetForm: require('/usr/src/app/components/auth-modal/password-reset-form.vue').default,LnModal: require('/usr/src/app/components/common-sections/ln-modal.vue').default})
